import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivityDto } from '@bo-client/shared/models/activityDto';

@Component({
  selector: 'app-activity-detail',
  templateUrl: './activity-detail.component.html',
  styleUrls: ['./activity-detail.component.scss']
})
export class ActivityDetailComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ActivityDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public activity: ActivityDto
  ) {}

  ngOnInit() {
    if (this.activity.type == 'AUDIT_ACTIVITY' && this.activity.information) {
      // todo try to convert @String to JSON
      this.activity.information = this.activity.information.split('(').join('<p>');
      this.activity.information = this.activity.information.split(')').join('</p>');
    }
    setTimeout(() => {
      if (document.querySelector('#onTop')) {
        document.querySelector('#onTop').scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 400);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
